module.exports = __webpack_public_path__ + "static/media/high-left-3.a852d211.png";